<template>
  <div class="home-container my-auto">

    <div class="home-header">
      <div class="home-logo"><img src="@/assets/img/logo.png"></div>
      <div class="col-md-12 header-title">Espace candidat</div>
      <div class="col-md-12 header-text">Bienvenue dans l'espace de candidature de la formation ASV avec APFORM.
        <div class="col-md-12 header-subtext">Suivez l'évolution de votre dossier chaque jour et soyez alerté des avancées.</div>
      </div>
    </div>

    <div class="home-login-group">
      <button class="btn btn-primary btn-block" @click="login">
        <span>Se connecter</span>
      </button>

      <div class="home-login-group-info">Pas encore inscrit ?</div>
      <div class="home-login-group-href">
        <router-link :to="{ name: 'public-register-approach'}" class="nav-link">
          Créer un compte
        </router-link>
      </div>
      <div class="home-login-group-help">
        <router-link :to="{ name: 'public-help-candidature'}" target="_blank">Aide à la candidature</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Home",
  data() {
    return {
      content: "",
    };
  },
  methods: {
    login: function () {
      this.$router.push({name: 'public-login'});
    }
  },
};
</script>
